import type { SocialProfileType } from '@/types/socialProfileType';

import type { DefaultAvatarProps } from '@/components/base/Avatar';
import { DefaultAvatar as Avatar } from '@/components/base/Avatar';
// Components
import Tooltip from '@/components/base/Tooltip';
import { ActiveBar } from '@/components/composite/SelectedProfiles/ActiveBar';
import { ProfileTooltip } from '@/components/composite/SelectedProfiles/ProfilesList/ProfileTooltip';

type ProfileItemProps = Pick<DefaultAvatarProps, 'size'> & {
    profile: SocialProfileType;
    isActive?: boolean;
    onClick?: () => void;
};

export function ProfileItem({
    profile,
    size = 'base',
    isActive = false,
    onClick
}: ProfileItemProps) {
    return (
        <div className="relative">
            <Tooltip
                interactive
                arrow={false}
                offset={[0, 4]}
                variant="profile_tooltip"
                content={<ProfileTooltip profile={profile} />}>
                <span>
                    <button
                        onClick={onClick}
                        disabled={isActive}
                        className="flex items-center rounded-full focus:ring-0 focus:ring-offset-0">
                        <Avatar
                            selected={isActive}
                            size={size}
                            url={profile?.external_api_data?.avatar ?? null}
                            fallback={profile?.slug[0]}
                            profileType={profile?.social_network_type}
                            error={profile?.auth_status.type === 'error'}
                            warning={profile?.auth_status.type === 'warning'}
                        />
                    </button>
                </span>
            </Tooltip>
            <ActiveBar isActive={isActive} />
        </div>
    );
}
